import type { SVGProps } from 'react';

const GiveCoins = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.25 19.75H4.75V13.25H7.25V15.25M7.25 19.75V15.25M7.25 19.75C14 19.75 19.25 16.5 19.25 16.5V14.25H13.25M7.25 15.25L10.78 13.368C10.9246 13.2907 11.086 13.2502 11.25 13.25H12.25C12.5152 13.25 12.7696 13.3554 12.9571 13.5429C13.1446 13.7304 13.25 13.9848 13.25 14.25M13.25 14.25V15.5L10.75 16.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.6458 7.35416V6.20833M20.0208 6.20833V7.875C20.0208 8.05516 19.8248 8.22004 19.5 8.34729M20.0208 6.20833C20.0208 6.61104 19.0415 6.9375 17.8333 6.9375C16.6252 6.9375 15.6458 6.61104 15.6458 6.20833M20.0208 6.20833C20.0208 5.80562 19.0415 5.47916 17.8333 5.47916C16.6252 5.47916 15.6458 5.80562 15.6458 6.20833"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.3542 9.125V10.7917C18.3542 11.1944 17.3748 11.5208 16.1667 11.5208C14.9586 11.5208 13.9792 11.1944 13.9792 10.7917V9.125M18.3542 9.125C18.3542 9.52771 17.3748 9.85417 16.1667 9.85417C14.9586 9.85417 13.9792 9.52771 13.9792 9.125M18.3542 9.125C18.3542 8.72229 17.3748 8.39584 16.1667 8.39584C14.9586 8.39584 13.9792 8.72229 13.9792 9.125"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default GiveCoins;
